import React from 'react'

export default function CardAbout() {
  return (
    <div className='cardAbout'>
      <h1>About</h1>
      <p>
        Collins Ruto is a self taught web and Android Developer and also a Designer.
        I'm well conversed with HTML/CSS, JavaScript and Reactjs for front-end,
        Nodejs, express and Nextjs for backend. Kotlin and Java for Android
      </p>
      <h1>Interests</h1>
      <p>
        I love programming of all things and Engineering. My best recreational activities
        are swimming, skating, chess and Basketball. I love reading and movies (binge watching)
        SCI-FI, investigative and drama.
      </p>
    </div>
  )
}
